

export class StateStatusInput implements IStateStatusInput {
    /** The auto-generated id of the state master */
    stateId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IStateStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateId = _data["stateId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StateStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new StateStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateId"] = this.stateId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IStateStatusInput {
    /** The auto-generated id of the state master */
    stateId: number;
    /** The updated status */
    status: number;
}

